import { render, staticRenderFns } from "./BaseRadioInput.vue?vue&type=template&id=e35346e0&"
import script from "./BaseRadioInput.vue?vue&type=script&lang=js&"
export * from "./BaseRadioInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports